import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CheckImageDirective } from '@shared/directives/check-image/check-image.directive.directive';

@NgModule({
  exports: [CheckImageDirective],
  declarations: [CheckImageDirective],
  imports: [CommonModule],
})
export class CheckImageModule {}
